var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 35,
    viewBox: "0 0 20 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0369 34.3074L0.506912 18.7929C0.32258 18.6082 0.192319 18.4081 0.116129 18.1926C0.0387092 17.9771 0 17.7463 0 17.5C0 17.2537 0.0387092 17.0229 0.116129 16.8074C0.192319 16.5919 0.32258 16.3918 0.506912 16.2071L16.0369 0.646438C16.467 0.215479 17.0046 0 17.6498 0C18.2949 0 18.8479 0.230871 19.3088 0.692612C19.7696 1.15435 20 1.69305 20 2.30871C20 2.92436 19.7696 3.46306 19.3088 3.9248L5.76037 17.5L19.3088 31.0752C19.7389 31.5062 19.9539 32.0368 19.9539 32.6673C19.9539 33.2989 19.7235 33.8456 19.2627 34.3074C18.8018 34.7691 18.2642 35 17.6498 35C17.0353 35 16.4977 34.7691 16.0369 34.3074Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideLeft);
export default __webpack_public_path__ + "static/media/slide-left.7309e8bc6e76fa62aca2cb0663a5fe5a.svg";
export { ForwardRef as ReactComponent };